import { environmentSelectorSelectors } from '../../../common/environment/selectors'
import { resourceSelectorSelectors } from '../../../common/resource/selectors'
import { versionSelectorSelectors } from '../../../common/version/selectors'
import { AppState } from '../../../types'

const selectors: any = {
  getAll: (state: AppState) => state.monitoring.logPoints,
  environmentSelector:
    environmentSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).environmentSelector),
  resourceSelector:
    resourceSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).resourceSelector),
  versionSelector:
    versionSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).versionSelector),
  landingPage: {
    environmentSelector:
      environmentSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).landingPage.environmentSelector),
    resourceSelector:
      resourceSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).landingPage.resourceSelector),
    versionSelector:
      versionSelectorSelectors<AppState>((state: AppState) => selectors.getAll(state).landingPage.versionSelector),
  }
}

export default selectors
